/* @generated */

// ../src/controls/checkbox/checkbox.tsx
import classNames from "classnames";
import * as React from "react";
import { useTheme } from "@dropbox/dig-foundations";

// ../src/_global/createAttachRef.tsx
var createAttachRef = (ref, innerRef) => {
  return (el) => {
    innerRef.current = el;
    if (ref) {
      if (typeof ref === "function") {
        ref(el);
      } else {
        ref.current = el;
      }
    }
  };
};

// ../src/controls/checkbox/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var checkboxInnerSpanStyle = "dig-1whq5ls8_22-5-0";
var checkboxInputRecipe = _7a468({ defaultClassName: "dig-1whq5ls3_22-5-0", variantClassNames: { initiallyChecked: { true: "dig-1whq5ls4_22-5-0" }, _pseudoClass: { hover: "dig-1whq5ls5_22-5-0", focus: "dig-1whq5ls6_22-5-0", active: "dig-1whq5ls7_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var checkboxStyle = "dig-1whq5ls0_22-5-0";
var checkedCheckboxIconStyle = "dig-1whq5ls2_22-5-0";
var indeterminateCheckboxIconStyle = "dig-1whq5ls1_22-5-0";

// ../src/controls/checkbox/checkbox.tsx
var Checkbox = React.forwardRef(
  ({
    _pseudoClass,
    checked,
    // `className` is being applied on the wrapper component since this is the box that represents
    // this Checkbox component and not the underlying `input` itself.
    className,
    isIndeterminate = false,
    inverse = false,
    // `style` is being applied on the wrapper component since this is the box that represents
    // this Checkbox component and not the underlying `input` itself.
    style = {},
    ...rest
  }, ref) => {
    const [hasInitialValueChanged, setHasInitialValueChanged] = React.useState(false);
    const initialValue = React.useRef(checked);
    const { getInverseProps } = useTheme();
    const { className: inverseClassName } = getInverseProps();
    React.useEffect(() => {
      if (!hasInitialValueChanged && checked !== initialValue.current) {
        setHasInitialValueChanged(true);
      }
    }, [checked, initialValue, hasInitialValueChanged]);
    const inputClasses = classNames(
      "dig-Checkbox-input",
      checkboxInputRecipe({
        initiallyChecked: !hasInitialValueChanged && checked,
        _pseudoClass
      }),
      {
        "dig-Checkbox--initiallyChecked": !hasInitialValueChanged && checked
      }
    );
    const wrapperClasses = classNames("dig-Checkbox", checkboxStyle, className, {
      [inverseClassName]: inverse
    });
    const innerRef = React.useRef();
    const attachRef = createAttachRef(ref, innerRef);
    React.useEffect(() => {
      if (innerRef.current) {
        innerRef.current.indeterminate = isIndeterminate;
      }
    }, [isIndeterminate, ref]);
    return /* @__PURE__ */ React.createElement("span", { className: wrapperClasses, style }, /* @__PURE__ */ React.createElement(
      "input",
      {
        checked,
        className: inputClasses,
        ref: attachRef,
        type: "checkbox",
        ...rest
      }
    ), /* @__PURE__ */ React.createElement("span", { className: classNames("dig-Checkbox-styles", checkboxInnerSpanStyle) }), /* @__PURE__ */ React.createElement(IndeterminateCheckboxIcon, null), /* @__PURE__ */ React.createElement(CheckedCheckboxIcon, null));
  }
);
Checkbox.displayName = "Checkbox";
var CheckedCheckboxIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className: classNames("dig-Checkbox-checked-icon", checkedCheckboxIconStyle),
    "aria-hidden": "true",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  },
  /* @__PURE__ */ React.createElement("path", { d: "M1 4L4.5 7.5L11 1", stroke: "currentColor", strokeWidth: "2", transform: "translate(4, 6)" })
);
CheckedCheckboxIcon.displayName = "CheckedCheckboxIcon";
var IndeterminateCheckboxIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    "aria-hidden": "true",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    className: classNames("dig-Checkbox-indeterminate-icon", indeterminateCheckboxIconStyle),
    focusable: "false"
  },
  /* @__PURE__ */ React.createElement("rect", { x: "5px", y: "9px", width: "10px", height: "2px" })
);
IndeterminateCheckboxIcon.displayName = "IndeterminateCheckboxIcon";

// ../src/controls/radio_button/radio_button.tsx
import classNames2 from "classnames";
import * as React2 from "react";
import { useTheme as useTheme2 } from "@dropbox/dig-foundations";

// ../src/controls/radio_button/index.css.ts
var radioActiveStyle = "dig-f28d32_22-5-0";
var radioFocusStyle = "dig-f28d31_22-5-0";
var radioHoverStyle = "dig-f28d30_22-5-0";
var radioStyle = "dig-f28d33_22-5-0";

// ../src/controls/radio_button/radio_button.tsx
var RadioButton = React2.forwardRef(
  ({ className, _pseudoClass, children: _children, inverse, ...rest }, ref) => {
    const { getInverseProps } = useTheme2();
    const { className: inverseClassName } = getInverseProps();
    const cls = classNames2("dig-Radio", radioStyle, className, {
      [inverseClassName]: inverse,
      [radioHoverStyle]: _pseudoClass === "hover",
      [radioFocusStyle]: _pseudoClass === "focus",
      [radioActiveStyle]: _pseudoClass === "active"
    });
    return /* @__PURE__ */ React2.createElement("input", { type: "radio", className: cls, ref, ...rest });
  }
);
RadioButton.displayName = "RadioButton";

// ../src/controls/segmented_control/segmented_control.tsx
import classNames5 from "classnames";
import * as React8 from "react";

// ../src/controls/segmented_control/option.tsx
import * as React6 from "react";
import classNames3 from "classnames";

// ../src/controls/segmented_control/context.tsx
import * as React5 from "react";

// ../src/controls/segmented_control/hooks/useOption.ts
import * as React3 from "react";
var useOption = (option, optionItems) => {
  const register = () => {
    optionItems.addOption(option);
  };
  const unregister = () => {
    optionItems.removeOption(option.value);
  };
  const update = () => {
    optionItems.updateOption(option);
  };
  React3.useEffect(() => {
    register();
    return () => unregister();
  }, []);
  React3.useEffect(() => {
    update();
  }, [option.value, option.element]);
};

// ../src/controls/segmented_control/hooks/useOptionItems.ts
import * as React4 from "react";
var initialState = {
  options: /* @__PURE__ */ new Map()
};
var reducer = (state, action) => {
  let changes;
  switch (action.type) {
    case "UPDATE_OPTION":
      const updateOptions = new Map(state.options);
      updateOptions.set(action.payload.key, action.payload.value);
      changes = { options: updateOptions };
      break;
    case "REMOVE_OPTION":
      const removeOptions = new Map(state.options);
      removeOptions.delete(action.payload.key);
      changes = { options: removeOptions };
      break;
  }
  return { ...state, ...changes };
};
var getElementByValue = (items, value) => {
  let returnElement = null;
  if (value !== void 0 && items.has(value)) {
    returnElement = items.get(value);
  }
  return returnElement;
};
var createOptionItems = () => ({
  items: /* @__PURE__ */ new Map(),
  updateOption: () => false,
  addOption: () => false,
  removeOption: () => false
});
var useOptionItems = () => {
  const [state, dispatch] = React4.useReducer(reducer, initialState);
  const updateOption = ({ value, element }) => {
    dispatch({
      type: "UPDATE_OPTION",
      payload: {
        key: value,
        value: element
      }
    });
  };
  const addOption = updateOption;
  const removeOption = (value) => {
    dispatch({
      type: "REMOVE_OPTION",
      payload: { key: value }
    });
  };
  return {
    items: state.options,
    updateOption,
    addOption,
    removeOption
  };
};

// ../src/controls/segmented_control/context.tsx
var defaultValue = {
  setSelectedOption: () => false,
  optionItems: createOptionItems()
};
var SegmentedControlContext = React5.createContext(defaultValue);

// ../src/controls/segmented_control/index.css.ts
import { createRuntimeFn as _7a4682 } from "@vanilla-extract/recipes/createRuntimeFn";
var segmentedControlActiveStyle = "dig-14yryv3_22-5-0";
var segmentedControlFocusStyle = "dig-14yryv2_22-5-0";
var segmentedControlHoverStyle = "dig-14yryv4_22-5-0";
var segmentedControlOptionRecipe = _7a4682({ defaultClassName: "dig-14yryv5_22-5-0", variantClassNames: { variant: { text: "dig-14yryv6_22-5-0", icon: "dig-14yryv7_22-5-0" }, disabled: { true: "dig-14yryv8_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var segmentedControlSelectorStyle = "dig-14yryv1_22-5-0";
var segmentedControlStyle = "dig-14yryv0_22-5-0";

// ../src/controls/segmented_control/option.tsx
var Option = React6.forwardRef(
  ({
    _pseudoClass,
    children,
    disabled,
    variant = "icon",
    value,
    // SegmentedControl is rendered as a tablist, so this needs to be a tab
    role = "tab",
    onClick,
    className,
    ...rest
  }, ref) => {
    const { setSelectedOption, optionItems, selectedElement } = React6.useContext(SegmentedControlContext);
    const localRef = React6.useRef(null);
    useOption({ value, element: localRef.current }, optionItems);
    const cls = classNames3(
      className,
      "dig-SegmentedControl-option",
      segmentedControlOptionRecipe({ variant, disabled }),
      `dig-SegmentedControl-option--${variant}`,
      {
        "dig-SegmentedControl-option--disabled": disabled,
        [segmentedControlActiveStyle]: _pseudoClass === "active",
        [segmentedControlFocusStyle]: _pseudoClass === "focus",
        [segmentedControlHoverStyle]: _pseudoClass === "hover"
      }
    );
    const handleClick = (evt) => {
      if (onClick) {
        onClick(evt);
      }
      setSelectedOption({ value, element: localRef.current });
    };
    React6.useImperativeHandle(ref, () => ({
      // `offsetWidth` and `offsetLeft` is required for selector translation
      offsetWidth: localRef.current ? localRef.current.offsetWidth : 0,
      offsetLeft: localRef.current ? localRef.current.offsetLeft : 0,
      // The set of properties below are used by `floating-ui`
      getBoundingClientRect: () => {
        if (!localRef.current) return;
        return localRef.current.getBoundingClientRect();
      }
    }));
    const ariaSelected = React6.useMemo(() => {
      if (selectedElement === void 0) {
        return "false";
      }
      return selectedElement === localRef.current ? "true" : "false";
    }, [selectedElement, localRef]);
    return /* @__PURE__ */ React6.createElement(
      "button",
      {
        role,
        className: cls,
        disabled,
        ref: localRef,
        onClick: handleClick,
        "aria-selected": ariaSelected,
        ...rest
      },
      children
    );
  }
);
Option.displayName = "Option";

// ../src/controls/segmented_control/selector.tsx
import * as React7 from "react";
import classNames4 from "classnames";
var Selector = ({ offsetWidth, offsetLeft }) => {
  const selectorRef = React7.useRef(null);
  React7.useEffect(() => {
    selectorRef.current.setAttribute(
      "style",
      `width: ${offsetWidth}px;
       transform: translate(${offsetLeft}px, 0);`
    );
  }, [offsetWidth, offsetLeft]);
  return /* @__PURE__ */ React7.createElement(
    "span",
    {
      ref: selectorRef,
      className: classNames4("dig-SegmentedControl-selector", segmentedControlSelectorStyle)
    }
  );
};

// ../src/controls/segmented_control/segmented_control.tsx
import { useTheme as useTheme3 } from "@dropbox/dig-foundations";
var SegmentedControl = ({
  className,
  children,
  selectedValue,
  onSelection,
  onValueChange,
  inverse = false,
  ...rest
}) => {
  const [didMount, setDidMount] = React8.useState(false);
  const optionItems = useOptionItems();
  const [selectedElement, setSelectedElement] = React8.useState(null);
  const { getInverseProps } = useTheme3();
  const { className: inverseClassName } = getInverseProps();
  const cls = classNames5("dig-SegmentedControl", segmentedControlStyle, className, {
    [inverseClassName]: inverse
  });
  React8.useEffect(() => {
    if (!didMount) {
      setDidMount(true);
    }
  }, []);
  React8.useEffect(() => {
    setSelectedElement(getElementByValue(optionItems.items, selectedValue));
  }, [optionItems.items, selectedValue]);
  React8.useEffect(() => {
    if (didMount && onValueChange) {
      onValueChange(selectedValue);
    }
  }, [selectedValue]);
  const setSelectedOption = (option) => {
    setSelectedElement(option.element ? option.element : null);
    if (onValueChange) {
      onValueChange(option.value);
    }
    if (onSelection) {
      onSelection(option.value);
    }
  };
  const contextValue = { setSelectedOption, optionItems, selectedElement };
  return /* @__PURE__ */ React8.createElement(SegmentedControlContext.Provider, { value: contextValue }, /* @__PURE__ */ React8.createElement("div", { role: "tablist", className: cls, ...rest }, selectedElement && /* @__PURE__ */ React8.createElement(
    Selector,
    {
      offsetWidth: selectedElement.offsetWidth,
      offsetLeft: selectedElement.offsetLeft
    }
  ), children));
};
SegmentedControl.displayName = "SegmentedControl";
SegmentedControl.Option = Option;

// ../src/controls/toggle/toggle.tsx
import classNames6 from "classnames";
import * as React9 from "react";
import { useTheme as useTheme4 } from "@dropbox/dig-foundations";

// ../src/controls/toggle/index.css.ts
import { createRuntimeFn as _7a4683 } from "@vanilla-extract/recipes/createRuntimeFn";
var toggleInputFocusStyle = "dig-6heq617_22-5-0";
var toggleInputStyle = "dig-6heq616_22-5-0";
var toggleRecipe = _7a4683({ defaultClassName: "dig-6heq610_22-5-0", variantClassNames: { isToggled: { true: "dig-6heq611_22-5-0" }, isDisabled: { true: "dig-6heq612_22-5-0" }, _pseudoClass: { active: "dig-6heq613_22-5-0", hover: "dig-6heq614_22-5-0", focus: "dig-6heq615_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var toggleTrackStyle = "dig-6heq618_22-5-0";

// ../src/controls/toggle/toggle.tsx
var Toggle = React9.forwardRef(
  ({ isToggled, disabled, className, wrapperProps, inverse, _pseudoClass, ...rest }, ref) => {
    const { getInverseProps } = useTheme4();
    const { className: inverseClassName } = getInverseProps();
    const labelClasses = classNames6(
      className,
      "dig-Toggle",
      toggleRecipe({ isToggled, isDisabled: disabled, _pseudoClass }),
      {
        "dig-Toggle--isToggled": isToggled,
        "dig-Toggle--disabled": disabled,
        [inverseClassName]: inverse
      }
    );
    return /* @__PURE__ */ React9.createElement("label", { className: labelClasses, ...wrapperProps }, /* @__PURE__ */ React9.createElement(
      "input",
      {
        role: "switch",
        type: "checkbox",
        className: classNames6("dig-Toggle-input", toggleInputStyle, {
          [toggleInputFocusStyle]: _pseudoClass === "focus"
        }),
        checked: isToggled,
        disabled,
        ref,
        ...rest
      }
    ), /* @__PURE__ */ React9.createElement("span", { className: classNames6("dig-Toggle-track", toggleTrackStyle) }));
  }
);
Toggle.displayName = "Toggle";
export {
  Checkbox,
  RadioButton,
  SegmentedControl,
  Toggle
};
